import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'
import '../src/util/install_sentry'
import 'Components/site/site_header/component'
import 'Components/site/site_header_navigation/component'
import 'Components/site/site_footer/component'
import 'Components/site/example_show/component'
import 'Components/site/floating/component'
import 'Components/site/call_to_action_button/component'
import 'Components/site/call_to_action_link/component'

import spToggleNav from '../src/spToggleNav/spToggleNav'
$(() => {
  spToggleNav()
})
